import { render } from "./HomePageFour.vue?vue&type=template&id=b1ec8f6a"
import script from "./HomePageFour.vue?vue&type=script&lang=js"
export * from "./HomePageFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__